
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minify",
      function () {
        return require("private-next-pages/minify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minify"])
      });
    }
  